import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as com from "./Common.js"
import './App.css';
import { Spinner } from 'react-bootstrap';
import { connect } from 'react-redux'


const mapStateToProps = (state) => {
    return {
        application: state.application,

    }
}

const mapDispatchToProps = (dispatch) => ({

});

/**
 * Borrower sign-in URL for this customer.
 * Use a same-origin relative path so host follows the current environment
 * (localhost / app.zeitro.us / app.zeitro.com / white-label app host).
 * Do not use customers.loginpath — that is LO /login, not borrower sign-in.
 */
function resolveBorrowerLoginUrl(customerId) {
    if (customerId === "individualcustomers") {
        const stored = (sessionStorage.getItem("logoutpath") || "").trim()
        if (stored) return stored
    }

    if (customerId) {
        return "/services/signin?customerid=" + encodeURIComponent(customerId)
    }
    return "/services/signin"
}


class LogoutPage extends Component  {

    componentDidMount = () => {
        // Capture before clearing ZeitroA — customerid comes from the JWT.
        const customerId = com.getCustomerId()
        const logoutpath = resolveBorrowerLoginUrl(customerId)

        window.setTimeout( () => {
        window.sessionStorage.removeItem("ZeitroA")
        window.sessionStorage.removeItem("state")    
        window.sessionStorage.removeItem("originalstate")    
        window.sessionStorage.removeItem("f1003")       
        window.sessionStorage.removeItem("newcustomer")       

        window.location.href = logoutpath
        }, 500 ) 
    }
    render = () => {

        return (

            <div id="spinner" className="pt-5 mt-5 w-100 text-center">
                    <Spinner animation='border' />
            </div>

        )
    }
}




export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(LogoutPage)
